import React, { useCallback, useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import DataTable from "../../../../../components/Common/DataTable/DataTable";
import Input from "../../../../../components/Common/Input/Input";
import Loader from "../../../../../components/Common/Loader/Loader";
import GroupArrowIcon from "../../../../../components/Common/SvgIcons/AdminIcons/GroupManagementIcons/GroupArrowIcon";
import {
  getSubgroupActionHandler,
  getSubgroupByIdActionHandler,
  getUserByNameInGroupManagementActionHandler,
  getUserGroupMembersHandler,
  postMemberActionHandler,
  setSubgroupActionHandler,
} from "../../../../../store/actions/actionHandlers/adminActionHandler/groupManagementActionHandler";
import { setErrorHandler } from "../../../../../store/actions/actionHandlers/errorActionHandler";
import { errorTypes } from "../../../../../utils/errorTypes";
import { groupManagement } from "../../../../../utils/mainTabs/admin/groupManagement/groupManagement";
import ManageGroupFooter from "../ManageGroupFooter/ManageGroupFooter";
import DeleteGroupSubgroup from "./DeleteGroupSubGroup/DeleteGroupSubgroup";
import classes from "./MangeGroupSubGroup.module.scss";
import {
  setManageSubgroupsCountAction,
  setManageUsersCountAction,
} from "../../../../../store/actions/actionCreators/adminActionCreator/groupManagementActionCreator";

const MangeGroupSubGroup = ({
  navigate,
  params,
  location,
  searchLabel,
  searchPlaceHolder,
  tenantName,
  handleSearchQuery,
}) => {
  const dispatch = useDispatch();
  const methods = useForm({});
  const { getValues } = methods;
  const [tableColumns, setTableColumns] = useState([]);
  const [searchtableColumns, setSearchTableColumns] = useState([]);
  const {
    groupManagementColumns,
    searchGroupManagementColumns,
    subgroupManagementColumns,
    searchSubgroupManagementColumns,
  } = groupManagement;
  const [searchGroupManagementTableData, setSearchGroupManagementTableData] =
    useState(null);
  const [searchGroupManagementLoader, SetsearchGroupManagementLoader] =
    useState(false);
  const searchVal = getValues("Search");
  const [postNameLoader, setPostNameLoader] = useState(false);
  const [groupManagementData, setgroupManagementData] = useState([]);
  const [groupManagementDataLoader, setgroupManagementDataLoader] =
    useState(false);
  const [existingGroupName, setExistingGroupName] = useState([]);
  const manageUsersPath = `${groupManagement?.path(tenantName)}/manageUsers/${
    params?.userGroupId
  }`;
  const manageSubgroupssPath = `${groupManagement?.path(
    tenantName
  )}/manageSubgroups/${params?.userGroupId}`;
  const [deleteGroupSubgroupModal, setDeleteGroupSubgroupModal] =
    useState(false);
  const [selectedgroupOrSubgroupMemeber, setSelectedgroupOrSubgroupMemeber] =
    useState(null);
  const [selectedTableData, setSelectedTableData] = useState([]);

  const getUserGroupMemeber = useCallback(() => {
    setgroupManagementDataLoader(true);
    const existingGroupNameArr = [];
    if (manageUsersPath === location?.pathname)
      dispatch(getUserGroupMembersHandler(params?.userGroupId, false)).then(
        (response) => {
          if (response?.status === 200) {
            setgroupManagementDataLoader(false);
            if (response?.data?.length > 0) {
              dispatch(setManageUsersCountAction(response?.data?.length));
              const updatedData = response?.data?.map((e, index) => {
                existingGroupNameArr.push(e?.UserId);
                setExistingGroupName([...new Set(existingGroupNameArr)]);
                return { ...e, ID: index + 1 };
              });
              setgroupManagementData(updatedData);
            } else {
              dispatch(setManageUsersCountAction(response?.data.length)); //Bug: 3330 - Set count to 0 when no users
              setgroupManagementData(response?.data);
              setExistingGroupName([]);
            }
          }
        }
      );
    else
      dispatch(getSubgroupByIdActionHandler(params?.userGroupId)).then(
        (response) => {
          if (response?.status === 200) {
            setgroupManagementDataLoader(false);
            if (response?.data?.UserSubGroups?.length > 0) {
              response?.data?.UserSubGroups?.forEach((e) => {
                existingGroupNameArr.push(e?.UserGroupId);
                setExistingGroupName([...new Set(existingGroupNameArr)]);
              });
            } else setExistingGroupName([]);
            dispatch(
              setManageSubgroupsCountAction(
                response?.data?.UserSubGroups?.length
              )
            );
            setgroupManagementData(response?.data);
          }
        }
      );
  }, [dispatch, params, location, manageUsersPath]);

  const searchCommonHandler = useCallback(
    (val) => {
      SetsearchGroupManagementLoader(true);
      if (manageUsersPath === location?.pathname)
        dispatch(getUserByNameInGroupManagementActionHandler(val)).then(
          (response) => {
            if (response?.status === 200 && response?.data) {
              const updatedData = response?.data?.filter?.(
                (e) => !existingGroupName.includes(e?.LoginId)
              );
              SetsearchGroupManagementLoader(false);
              setSearchGroupManagementTableData(updatedData);
            }
          }
        );
      else
        dispatch(getSubgroupActionHandler(val, true, params?.userGroupId)).then(
          (response) => {
            if (response?.status === 200 && response?.data) {
              const updatedData = response?.data?.UserGroups?.filter?.(
                (e) => !existingGroupName.includes(e?.UserGroupId)
              );
              SetsearchGroupManagementLoader(false);
              setSearchGroupManagementTableData(updatedData);
            }
          }
        );
    },
    [dispatch, existingGroupName, location, manageUsersPath, params]
  );

  const handleDelete = useCallback((row) => {
    setDeleteGroupSubgroupModal(true);
    setSelectedgroupOrSubgroupMemeber(row);
  }, []);

  const searchHandler = (e) => {
    const val = e.target.value.trim();
    if (val) {
      searchCommonHandler(val);
    } else setSearchGroupManagementTableData(null);
  };

  const onCancelClick = () => {
    navigate(groupManagement?.path(tenantName));
    handleSearchQuery();
  };

  const onSubmitClick = () => {
    // const selectedMember = searchGroupManagementTableData?.filter(
    //   (e) => e?.checked === true
    // );
    if (selectedTableData?.length > 0) {
      setPostNameLoader(true);
      if (manageUsersPath === location?.pathname) {
        const updatedSelectedMember = selectedTableData.map(function (item) {
          delete item?.checked;
          return {
            ...item,
            UserGroupId: parseInt(params?.userGroupId),
            UserId: item?.ID,
          };
        });
        dispatch(
          postMemberActionHandler(params?.userGroupId, updatedSelectedMember)
        ).then((response) => {
          if (response?.status === 200 && response?.data) {
            setPostNameLoader(false);
            dispatch(
              setErrorHandler(
                errorTypes.SUCCESS,
                "Users are saved successfully......"
              )
            );
            getUserGroupMemeber();
          } else dispatch(setErrorHandler(errorTypes.FAIL, "failed"));
        });
      } else {
        const updatedSelectedMember = selectedTableData.map(function (item) {
          delete item?.checked;
          return item;
        });
        const obj = {
          ...groupManagementData,
          UserSubGroups: updatedSelectedMember,
        };
        dispatch(setSubgroupActionHandler(params?.userGroupId, obj)).then(
          (response) => {
            if (response?.status === 200 && response?.data) {
              setPostNameLoader(false);
              dispatch(
                setErrorHandler(
                  errorTypes.SUCCESS,
                  "Subgroup successfully added"
                )
              );
              getUserGroupMemeber();
            } else dispatch(setErrorHandler(errorTypes.FAIL, "failed"));
          }
        );
      }
    } else
      dispatch(
        setErrorHandler(
          errorTypes.WARN,
          manageUsersPath === location?.pathname
            ? "Please select some users to add"
            : "Please select some subgroups to add"
        )
      );
    setSelectedTableData([]);
  };

  useEffect(() => {
    getUserGroupMemeber();
  }, [getUserGroupMemeber]);

  useEffect(() => {
    let newTableColumns =
      manageUsersPath === location?.pathname
        ? groupManagementColumns(handleDelete)
        : subgroupManagementColumns(handleDelete);
    setTableColumns(newTableColumns);
  }, [
    groupManagementColumns,
    handleDelete,
    location,
    manageUsersPath,
    subgroupManagementColumns,
  ]);

  useEffect(() => {
    if (existingGroupName && searchVal) {
      searchCommonHandler(searchVal);
    }
  }, [existingGroupName, searchCommonHandler, searchVal]);

  useEffect(() => {
    let newSearchTableColumns =
      manageUsersPath === location?.pathname
        ? searchGroupManagementColumns()
        : searchSubgroupManagementColumns();
    setSearchTableColumns(newSearchTableColumns);
  }, [
    searchGroupManagementColumns,
    location,
    manageUsersPath,
    searchSubgroupManagementColumns,
  ]);

  useEffect(() => {
    if (searchGroupManagementTableData) {
      const selectedMember = searchGroupManagementTableData?.filter(
        (e) => e?.checked === true
      );
      // if (location?.pathname === manageUsersPath) {
      // } else {
      // }

      const unSelectedData = [];
      searchGroupManagementTableData?.forEach((e) => {
        if (e?.checked === false)
          unSelectedData.push(
            location?.pathname === manageUsersPath ? e?.ID : e?.UserGroupId
          );
      });

      setSelectedTableData((prevData) => {
        const newData = [...prevData, ...selectedMember];
        const uniqueData = Array.from(
          new Set(
            newData.map((item) =>
              location?.pathname === manageUsersPath
                ? item.ID
                : item?.UserGroupId
            )
          )
        ).map((id) =>
          newData.find((item) =>
            location?.pathname === manageUsersPath
              ? item.ID === id
              : item.UserGroupId === id
          )
        );
        // Remove items from uniqueData that are in unSelectedData
        const filteredUniqueData = uniqueData.filter(
          (item) =>
            !unSelectedData.includes(
              location?.pathname === manageUsersPath
                ? item.ID
                : item?.UserGroupId
            )
        );

        return filteredUniqueData;
      });
    }
  }, [searchGroupManagementTableData]);

  return (
    <>
      <div className={classes.manageGroup}>
        {((groupManagementData?.length > 0 &&
          location?.pathname === manageUsersPath) ||
          (groupManagementData?.UserSubGroups?.length > 0 &&
            location?.pathname === manageSubgroupssPath)) && (
          <DataTable
            columns={tableColumns}
            defaultData={groupManagementData}
            data={
              manageUsersPath === location?.pathname
                ? groupManagementData
                : groupManagementData?.UserSubGroups
            }
            totalRows={
              manageUsersPath === location?.pathname
                ? groupManagementData?.length
                : groupManagementData?.UserSubGroups?.length
            }
            loading={groupManagementDataLoader}
            uniqueFieldName={
              manageUsersPath === location?.pathname ? "ID" : "UserGroupId"
            }
          />
        )}
        {groupManagementDataLoader && (
          <div className={classes.loader}>
            <Loader height="50" width="50" />
          </div>
        )}
        {((groupManagementData?.length === 0 && !groupManagementDataLoader) ||
          (groupManagementData?.UserSubGroups?.length === 0 &&
            !groupManagementDataLoader)) && (
          <div className={classes.noRecordFound}>
            {manageUsersPath === location?.pathname
              ? "No Users Found"
              : " No Subgroups Found"}
          </div>
        )}
        <div className={classes.addNewUser}>
          <GroupArrowIcon />
          <div className={classes.text}>{searchLabel}</div>
        </div>
        <div className={classes.searchbox}>
          <FormProvider {...methods}>
            <Input
              name="Search"
              placeholder={searchPlaceHolder}
              labelColor="light"
              search={true}
              height={4}
              width={30}
              gap={0}
              onChange={searchHandler}
            />
          </FormProvider>
        </div>
        {searchGroupManagementLoader && searchVal && (
          <div className={classes.loader}>
            <Loader height="50" width="50" />
          </div>
        )}
        {!searchGroupManagementLoader &&
          searchGroupManagementTableData?.length > 0 && (
            <DataTable
              columns={searchtableColumns}
              defaultData={searchGroupManagementTableData}
              setDefaultData={setSearchGroupManagementTableData}
              data={searchGroupManagementTableData}
              setData={setSearchGroupManagementTableData}
              totalRows={searchGroupManagementTableData?.length}
              loading={searchGroupManagementLoader}
              uniqueFieldName={
                manageUsersPath === location?.pathname ? "ID" : "UserGroupId"
              }
              selectableRows
            />
          )}
        <ManageGroupFooter
          onCancelClick={onCancelClick}
          onSubmitClick={onSubmitClick}
          loading={postNameLoader}
        />
      </div>
      {deleteGroupSubgroupModal && (
        <DeleteGroupSubgroup
          deleteModal={deleteGroupSubgroupModal}
          setDeleteModal={setDeleteGroupSubgroupModal}
          selectedData={selectedgroupOrSubgroupMemeber}
          manageUsersPath={manageUsersPath}
          location={location}
          params={params}
          getUserGroupMemeber={getUserGroupMemeber}
          setSelectedTableData={setSelectedTableData}
        />
      )}
    </>
  );
};

export default MangeGroupSubGroup;
